package com.eladfinish.bible.contest.common.api

import io.ktor.client.HttpClient
import io.ktor.client.request.forms.submitForm
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ParametersBuilder

interface GoogleFormApi {
    suspend fun postData(
        id: String,
        keys: List<String>,
        values: List<String>,
    ): HttpResponse
}

class GoogleFormApiImpl(
    private val client: HttpClient,
) : GoogleFormApi {

    companion object {
        private const val DOCS_URL = "https://docs.google.com"
    }

    override suspend fun postData(
        id: String,
        keys: List<String>,
        values: List<String>,
    ): HttpResponse {
        require(keys.size == values.size) {
            "Keys size (${keys.size}) must match values size (${values.size})"
        }

        return client.submitForm(
            url = "$DOCS_URL/forms/d/e/$id/formResponse",
            formParameters = ParametersBuilder().apply {
                keys.zip(values).forEach { (key, value) ->
                    append(key, value)
                }
            }.build(),
        )
    }

}
